import { Alert, AlertDescription, Button, Input, Label } from '@sitewise/ui';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';


import { vendorRequestLink } from '../../api/vendor-auth.js';

import { AuthShell } from './auth-shell.js';

export function VendorRequestPage() {
  const [email, setEmail] = useState('');
  const mutation = useMutation({
    mutationFn: () => vendorRequestLink(email),
  });

  return (
    <AuthShell
      title="Vendor sign-in"
      description="Enter the email on file with this organization. We'll email you a one-time sign-in link."
      footer={
        <Link to="/login" className="text-fg hover:underline">
          Staff sign-in
        </Link>
      }
    >
      {mutation.isSuccess ? (
        <Alert variant="success">
          <AlertDescription>
            Check your inbox at <strong>{email}</strong>. The link expires in 1 hour.
          </AlertDescription>
        </Alert>
      ) : (
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            mutation.mutate();
          }}
          noValidate
        >
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <Button type="submit" className="w-full" disabled={mutation.isPending}>
            {mutation.isPending ? 'Sending…' : 'Email me a sign-in link'}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
